import {BLOG} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

import type {BlogPostType} from './blogPostType';

const initialState = {
    categories: [{name: ''}],
    id: 0,
    content: '',
    title: '',
    created_time: '',
    status: 'pending',
};

/**
 * Get blog post
 * @param {BlogPostType} state - Current state
 * @param {ActionType<BlogPostType>} action - Received action
 * @returns {BlogPostType} blog post data
 */
export default function blogPost(
    state: BlogPostType = initialState,
    action: ActionType<BlogPostType>,
): BlogPostType {
    switch (action.type) {
        case `${BLOG.GET_ONE_POST}_FULFILLED`:
            return {...state, ...action.payload.data, status: 'fulfilled'};
        case `${BLOG.GET_ONE_POST}_PENDING`:
            return {...state, status: 'pending'};
        case `${BLOG.GET_ONE_POST}_REJECTED`:
            return {...state, messages: action.payload.response.data.messages, status: 'rejected'};
        default:
            return state;
    }
}
